import { mergeClassNames } from "../../utils/classes";
import { Paragraph } from "../TypographicElements/TypographicElements";

import type { CSSProperties } from "react";

import * as styles from "./loadingSpinner.module.scss";

export interface LoadingSpinnerProps {
	/**
	 * @default "medium"
	 */
	size?: "extra-small" | "small" | "medium" | "large";
	/**
	 * @default "dark"
	 */
	appearance?: "dark" | "light";
	/**
	 * Optional loading message to display below the spinner.
	 */
	message?: string;
}

const sizeToPixels: Record<NonNullable<LoadingSpinnerProps["size"]>, number> = {
	"extra-small": 12,
	small: 20,
	medium: 32,
	large: 48,
};

export const loadingSpinnerDefaults = {
	size: "medium",
	appearance: "dark",
} satisfies Partial<LoadingSpinnerProps>;

export const LoadingSpinner = ({
	size = loadingSpinnerDefaults.size,
	appearance = loadingSpinnerDefaults.appearance,
	message,
}: LoadingSpinnerProps) => {
	const spinnerStyle: CSSProperties & Record<"--loading-spinner-size", string> = {
		"--loading-spinner-size": `${sizeToPixels[size]}px`,
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: "8px",
			}}
		>
			<span
				className={mergeClassNames(styles.circle, appearance === "dark" ? styles.dark : styles.light)}
				style={spinnerStyle}
				data-testid="LoadingSpinner"
			/>
			{message && <Paragraph textCenter>{message}</Paragraph>}
		</div>
	);
};
